<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="360px"
    top="calc(15vh + 40px)"
    :modal="false"
    custom-class="free-dialog"
    :before-close="handleClose"
  >
    <div>
      <form
        id="payment-form"
        v-loading="loading">
        <div id="payment-element">
        </div>
        <button
          id="submit"
          :disabled="submitBlock"
          class="pay-submit"
          @click="handleSubmit">Submit</button>
        <div id="error-message">
          {{ errorMmessage }}
        </div>
      </form>
    </div>
    <!-- <div v-if="dialogVisible">
        <iframe :src="iframeSrc" frameborder="0"></iframe>
      </div> -->
  </el-dialog>

</template>

<script>
export default {
  name: 'AddPayments',
  data () {
    return {
      dialogVisible: false,
      stripeObj: {},
      errorMmessage: '',
      loading: true,
      callback: null,
      iframeSrc: '',
      submitBlock: false
    }
  },
  methods: {
    open (clientSecret, callback) {
      this.dialogVisible = true
      let theme = 'stripe'
      try {
        const themevalue = document.cookie.match(/theme=([^;]*)/)[1]
        if (themevalue == 'dark') {
          theme = 'night'
        }
      } catch (error) {
        console.log(error)
      }
      this.$nextTick(() => {
        this.initStripe(clientSecret, theme)
        // this.initCheckOut(clientSecret)
      })
      // this.iframeSrc = clientSecret
      this.callback = callback
      // const form = document.getElementById('payment-form');
    },
    async initCheckOut (clientSecret) {
      const stripe = window.Stripe(window.CONFIG.stripePublishKey)
      window.stripe = stripe
      // initCheckout initEmbeddedCheckout
      const checkout = await stripe.initEmbeddedCheckout({
        fetchClientSecret: () => {
          return clientSecret
        },
        onComplete: (result) => {
          console.log('onComplete', result)
        }

      })

      // Mount Checkout
      checkout.mount('#payment-element')
      window.checkout = checkout
      console.log('checkout', checkout)

      this.$nextTick(() => {
        this.loading = false
      })
    },
    initStripe (clientSecret, theme) {
      const stripe = window.Stripe(window.CONFIG.stripePublishKey)

      const options = {
        clientSecret,
        // Fully customizable with appearance API.
        appearance: {
          theme,
          labels: 'floating'
        }
      }
      console.log(theme)
      // Set up Stripe.js and Elements to use in checkout form, passing the client secret obtained in step 2
      const elements = stripe.elements(options)

      // Create and mount the Payment Element
      const paymentElement = elements.create('payment')
      paymentElement.mount('#payment-element')
      this.stripeObj = { stripe, elements }
      const dom = document.querySelector('#payment-element')
      const iframe = dom.querySelector('iframe')
      dom.style['min-height'] = '250px'
      iframe.onload = () => {
        setTimeout(() => {
          this.loading = false
          // dom.style.height = 'auto'
        }, 2000)
      }
    },
    async handleSubmit (e) {
      e.preventDefault()
      this.submitBlock = true
      const { stripe, elements } = this.stripeObj
      const { error } = await stripe.confirmSetup({
        // `Elements` instance that was used to create the Payment Element
        elements,
        redirect: 'if_required'
      })

      if (error) {
        // This point will only be reached if there is an immediate error when
        // confirming the payment. Show error to your customer (for example, payment
        // details incomplete)
        // const messageContainer = document.querySelector('#error-message');
        // messageContainer.textContent = error.message;
        this.submitBlock = false
        this.errorMmessage = error.message

        // this.close('error')
      } else {
        // Your customer will be redirected to your `return_url`. For some payment
        // methods like iDEAL, your customer will be redirected to an intermediate
        // site first to authorize the payment, then redirected to the `return_url`.
        console.log('successfully')
        this.close('success')
      }
    },
    handleClose () {
      this.close('cancel')
    },
    close (type) {
      this.dialogVisible = false
      this.submitBlock = false
      this.stripeObj = {}
      this.errorMmessage = ''
      typeof this.callback && this.callback(type)
    }
  }
}
</script>

<style>
.pay-submit{
  display: block;
  margin: 10px auto 0;
  border: none;
  outline: none;
  cursor: pointer;
  border: 1px solid #c0c0c0;
  padding: 5px 10px;
  border-radius: 5px;
}
</style>
